export const resultPaginationReducerKey = 'resultsPagination';
export const setDropdownValuesType = 'SET_PAGINATION_DROPDOWN_VALUES';
export const PAGE_RANGE_MIN = 3;
export const PAGE_RANGE_MAX = 5;
export const GO_TO_PAGE_MIN_PAGES = 7;
